module.exports = __webpack_public_path__ + "images/help_v2/avatars/yunfei-2f41e1662f5b53424c7553bc0ea5fdcd.png";